<template>
  <div>
    <div id="gundem" class="table-responsive">
      <div class="title">{{ $t('app.agenda') }}</div>
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>{{ $t('app.datetime') }}</th>
            <th>{{ $t('app.country') }}</th>
            <th>{{ $t('app.importance') }}</th>
            <th>{{ $t('app.period') }}</th>
            <th>{{ $t('app.data') }}</th>
            <th>{{ $t('app.expectation') }}</th>
            <th>{{ $t('app.before') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in gundem" v-bind:key="item.id">
            <td>{{ item.tarih + item.saat }}</td>
            <td>{{ item.ulke }}</td>
            <td>{{ item.onem }}</td>
            <td>{{ item.veri }}</td>
            <td>{{ item.beklenti }}</td>
            <td>{{ item.onceki }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"])
  },
  data: function() {
    return {
      gundem: []
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
        "cmd=Gundem" +
          "?lang=" +
          this.$i18n.locale,
        {
          responseType: "arraybuffer",
          responseEncoding: "binary"
        }
      )
      .then(response => this.initXML(response));
  },
  methods: {
    initXML: function(response) {
      var respData = iconv.decode(Buffer.from(response.data), "ISO-8859-9");
      let parser = new DOMParser();
      let doc = parser.parseFromString(respData, "application/xml");
      let data = doc.querySelectorAll("data");
      data.forEach(el => {
        this.gundem.push({
          tarih: el.querySelector("tarih").textContent,
          saat: el.querySelector("saat").textContent,
          ulke: el.querySelector("ulke").textContent,
          onem: el.querySelector("onem").textContent,
          donem: el.querySelector("donem").textContent,
          veri: el.querySelector("veri").textContent,
          beklenti: el.querySelector("beklenti").textContent,
          onceki: el.querySelector("onceki").textContent
        });
      });
    }
  }
};
</script>

<style scoped>
#gundem {
  height: 550px;
  overflow: scroll;
}
</style>
